import http from '@/utils/ky'
import Events from '@/utils/events'
import { API } from '@/config'

export default {
	async checkAuth({ commit }, payload) {
		try {
			let { data } = await http.get(API.AUTH.check)
			if (!data || data.err) return

			commit('setUser', data)
			return data
		} catch (err) {
			console.log('err check auth')
			console.log(err)
			return err
		}
	},

	async loadInitialData({ commit, getters, state }) {
		let toLoad = {
			me: true,
			chats: false,
			tickets: false,
			calls: false,
			admins: false,
			articles: false,
			stories: false,
			consultations: false,
		}

		if (getters.hasRole('god')) {
			Object.keys(toLoad).map((key) => {
				toLoad[key] = true
			})
		} else {
			if (getters.hasRole('dogology')) {
				toLoad.chats = true
				toLoad.tickets = true
			}
			if (getters.hasRole('support')) {
				toLoad.chats = true
				toLoad.tickets = true
				toLoad.calls = true
				toLoad.admins = true
			}
			if (getters.hasRole('editor')) {
				toLoad.articles = true
			}
		}

		let promises = []

		if (toLoad.me) {
			promises.push(http.get(API.AUTH.me, undefined, {}, 'me'))
		}
		if (toLoad.chats) {
			promises.push(http.get(API.CHATS.list, undefined, {}, 'chats'))
		}
		if (toLoad.tickets) {
			promises.push(http.get(API.TICKETS.list, undefined, {}, 'tickets'))
		}
		if (toLoad.calls) {
			promises.push(http.get(API.CALLS.list, undefined, {}, 'calls'))
		}
		if (toLoad.admins) {
			promises.push(http.get(API.USERS.admins, undefined, {}, 'admins'))
		}
		if (toLoad.articles) {
			promises.push(http.get(API.ARTICLES.list, undefined, {}, 'articles'))
		}
		if (toLoad.stories) {
			promises.push(http.get(API.STORIES.list, undefined, {}, 'stories'))
		}
		if (toLoad.consultations) {
			promises.push(
				http.get(API.CONSULTATIONS.list, undefined, {}, 'consultations')
			)
		}

		let data = await Promise.all(promises)

		data.forEach((p) => {
			if (p && p.custom === 'me') {
				if (p.data && !p.data.err) commit('setUser', p.data)
			}
			if (p && p.custom === 'chats') {
				if (p.data && !p.data.err)
					commit('setArray', { path: 'chats', data: p.data })
			}
			if (p && p.custom === 'tickets') {
				if (p.data && !p.data.err)
					commit('setArray', { path: 'tickets', data: p.data })
			}
			if (p && p.custom === 'calls') {
				if (p.data && !p.data.err)
					commit('setArray', { path: 'calls', data: p.data })
			}
			if (p && p.custom === 'admins') {
				if (p.data && !p.data.err)
					commit('setArray', { path: 'admins', data: p.data })
			}
			if (p && p.custom === 'articles') {
				if (p.data && !p.data.err) {
					commit('setArray', { path: 'articles', data: p.data.articles })
					commit('setArray', { path: 'categories', data: p.data.categories })
				}
			}
			if (p && p.custom === 'stories') {
				if (p.data && !p.data.err)
					commit('setArray', { path: 'stories', data: p.data })
			}
			if (p && p.custom === 'consultations') {
				if (p.data && !p.data.err)
					commit('setArray', { path: 'consultations', data: p.data })
			}
		})
	},

	async fetchChatMessage({ commit, getters, state }, payload) {
		let exist = state.chats.find((c) => c.id === payload.chat)
		if (!exist) return

		let { data } = await http.get(API.CHATS.message + payload.id)
		if (!data || data.err) return console.log('can not load message', payload.id)

		let d = { message: data, chat: payload.chat }
		commit('updateChatMessages', d)
		Events.$emit('addChatMessage', d)
	},

	async fetchTicket({ commit, getters, state }, payload) {
		let { data } = await http.get(API.TICKETS.get + payload.id)
		if (!data || data.err) return console.log('can not load ticket', payload.id)

		commit('updateInArray', { path: 'tickets', data: data })
	},

	async fetchCall({ commit, getters, state }, payload) {
		let { data } = await http.get(API.CALLS.get + payload.id)
		if (!data || data.err) return console.log('can not load call', payload.id)

		commit('updateInArray', { path: 'calls', data: data })
	},

	async updateChatAndTicket({ commit, getters, state }, payload) {
		let [ticket, chat] = await Promise.all([
			http.get(API.TICKETS.get + payload.ticket),
			http.get(API.CHATS.get + payload.chat),
		])
		if (!ticket.data || ticket.data.err)
			return console.log('can not load ticket', payload.ticket, ticket.data.err)
		if (!chat.data || chat.data.err)
			return console.log('can not load ticket', payload.chat, chat.data.err)

		commit('updateInArray', { path: 'tickets', data: ticket.data })
		commit('updateInArray', { path: 'chats', data: chat.data })

		Events.$emit('chatAndTicketUpdated', { ticket: ticket.data, chat: chat.data })
	},

	async deleteChatAndTicket({ commit, getters, state }, payload) {
		const { ticket, chat } = payload
		state.tickets = state.tickets.filter(t => t.id !== ticket)
	},
}
